<mat-progress-bar
  *ngIf="pageState === 'waiting'"
  mode="indeterminate"
></mat-progress-bar>

<div *ngIf="pageState === 'error'" class="extra-narrow-content">
  <mat-card>
    <mat-card-header>
      <mat-card-title> User not found. </mat-card-title>
    </mat-card-header>
  </mat-card>
</div>

<div *ngIf="pageState === 'ready'" class="extra-narrow-content">
  <mat-card>
    <mat-card-content>
      <h2>Edit user</h2>

      <section class="edit-text">
        <mat-form-field class="auto-margin">
          <mat-label>Name</mat-label>
          <input
            [formControl]="nameControl"
            matInput
            [readonly]="!canEditName"
            (keydown.enter)="saveName()"
          />
        </mat-form-field>
        <div class="auto-margin" *ngIf="canEditName">
          <button
            mat-raised-button
            color="primary"
            [disabled]="!nameChanged || nameUpdateState === 'waiting'"
            (click)="saveName()"
          >
            <mat-icon *ngIf="nameUpdateState === 'waiting'">
              <mat-spinner
                [color]="'accent'"
                [mode]="'indeterminate'"
                [diameter]="20"
              >
              </mat-spinner>
            </mat-icon>
            {{
              nameUpdateState === 'waiting'
                ? 'Saving'
                : nameUpdateState === 'complete'
                ? 'Saved'
                : 'Save'
            }}
          </button>
        </div>
      </section>

      <section>Email: {{ user.email }}</section>

      <section *ngIf="canInvite">
        <button mat-raised-button color="primary" (click)="sendInvite()">
          Send invite
        </button>
      </section>

      <section *ngIf="invite">
        Invite pending
        <button
          *ngIf="authUserIsAdmin"
          mat-raised-button
          color="warn"
          (click)="cancelInvite()"
        >
          Cancel invite
        </button>
      </section>

      <section *ngIf="canMakeAdmin">
        <button mat-raised-button color="primary" (click)="makeAdmin()">
          Make admin
        </button>
      </section>

      <section *ngIf="canRemoveAdmin">
        <button mat-raised-button color="primary" (click)="removeAdmin()">
          Remove admin
        </button>
      </section>

      <section *ngIf="canArchive">
        <button mat-raised-button color="warn" (click)="archiveUser()">
          Archive user
        </button>
      </section>
    </mat-card-content>
  </mat-card>
</div>
